import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

function Loader() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
     // bgcolor="rgba(0, 0, 0, 0.3)" // Semi-transparent background for better visibility
    >
      <CircularProgress size={80} thickness={4} style={{ color: '#1976d2' }} />
    </Box>
  );
}

export default Loader;
